import { Injectable } from '@angular/core';
import { portalConst } from '@app/config';
import { TrailsService } from '@app/modules/learning-trails/services';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class LearningTrailsCategoryService {
  constructor(private api: ApiService, private trailsService: TrailsService) {}

  public postCategory(data): Observable<any> {
    return this.api.post(`${portalConst.api.trilhas}/v1/categorias`, { ...data, ...this.checkUcIvca() });
  }

  public updateCategory(data): Observable<any> {
    return this.api.put(`${portalConst.api.trilhas}/v1/categorias/${data.id}`, data);
  }

  public deleteCategory(id): Observable<any> {
    return this.api.delete(`${portalConst.api.trilhas}/v1/categorias/${id}`);
  }

  private checkUcIvca(): any {
    if (this.trailsService.uc$.value) return { uc: true };
    if (this.trailsService.ivca$.value) return { ivca: true };
    return {};
  }
}
